import { t } from "i18next";
import { RiskFactor, TreatmentType } from "@keita/lanepatrol-sdk";
import { OsaNode } from "../../osaway/models/OsaNode";
import { downloadFile } from "../../shared/utils/file-utils";
import { OsaWay } from "../../osaway/models/OsaWay";
import { Project } from "../models/Project";

type TreatmentCSV = {
  project: string;
  route: string;
  node: number;
  nodeName: string;
  treatmentType?: TreatmentType;
  treatmentRanking?: number;
  actualScore?: number;
  actualRisk?: RiskFactor;
  newTreatmentScore?: number;
  newTreatmentRisk?: RiskFactor;
};

export const treatmentExport = (
  project: Project,
  ways: OsaWay[],
  allNodes: Map<string, OsaNode[]>
) => {
  if (!ways.length) return;

  const treatmentCSVItems: TreatmentCSV[] = [];
  ways.forEach((way) => {
    allNodes.get(way.id)?.forEach((node, i) => {
      if (node.treatments!.length > 0) {
        node.treatments!.forEach((treatment, index) => {
          if (index > 2) return;
          treatmentCSVItems.push({
            project: project.name,
            route: way.name,
            node: i + 1,
            nodeName: node.name,
            treatmentType: treatment.type,
            treatmentRanking: index + 1,
            actualScore: node.score?.global!.value!,
            actualRisk: node.score!.global.riskFactor,
            newTreatmentScore: treatment.score.global.value,
            newTreatmentRisk: treatment.score.global.riskFactor,
          });
        });
      } else {
        treatmentCSVItems.push({
          project: project.name,
          route: way.name,
          node: i + 1,
          nodeName: node.name,
          treatmentType: undefined,
          treatmentRanking: undefined,
          actualScore: node.score?.global.value,
          actualRisk: node.score?.global.riskFactor,
          newTreatmentScore: undefined,
          newTreatmentRisk: undefined,
        });
      }
    });
  });
  const titleKeys = Object.keys(treatmentCSVItems![0]).map((key) =>
    t(`map:treatments.exportCSV.${key}`)
  );
  const refinedData = [];

  refinedData.push(titleKeys);

  treatmentCSVItems?.forEach((item) => {
    refinedData.push(Object.values(item).map((value) => value ?? ""));
  });
  let csvContent = "";
  refinedData.forEach((row) => {
    csvContent += row.join(",") + "\n";
  });

  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8," });
  downloadFile(blob, `Treatments_${new Date().getTime()}.csv`);
};
